var _defs, _rect, _path, _rect2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#54575a;}.cls-3{fill:#3d85c6;stroke:#54575a;stroke-miterlimit:10;stroke-width:15px;}.cls-4{fill:#939598;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.5,
    y: 25.5,
    width: 1149,
    height: 1149,
    rx: 95.94,
    ry: 95.94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1078.56,35.5a86.26,86.26,0,0,1,85.94,85.94v957.11a86.26,86.26,0,0,1-85.94,85.94H121.44a86.26,86.26,0,0,1-85.94-85.94V121.44A86.26,86.26,0,0,1,121.44,35.5h957.11m0-20H121.44C63.18,15.5,15.5,63.18,15.5,121.44v957.11c0,58.27,47.68,105.94,105.94,105.94h957.11c58.27,0,105.94-47.68,105.94-105.94V121.44c0-58.27-47.68-105.94-105.94-105.94Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 107,
    y: 469.5,
    width: 986,
    height: 261,
    rx: 22.38,
    ry: 22.38
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M743.73,803.25a5.78,5.78,0,0,1-4.47-2.1l-36.15-43.75-31.51,26a9.77,9.77,0,0,1-6.29,2.3,10,10,0,0,1-9.91-8.34L635.12,657a9.77,9.77,0,0,1,2.18-8.06,9.86,9.86,0,0,1,11.15-2.95L762.9,688.59a10,10,0,0,1,2.87,17l-35,28.9,36.15,43.75a5.79,5.79,0,0,1-.78,8.15l-18.76,15.5a5.71,5.71,0,0,1-3.68,1.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M644.91,652.8a2.59,2.59,0,0,1,.91.18l114.46,42.64a2.48,2.48,0,0,1,.71,4.24L731.8,724l-11.56,9.55,9.55,11.56,30.28,36.64L744,795.06l-30.28-36.64-9.55-11.56-11.56,9.55-25.72,21.25a2.28,2.28,0,0,1-1.51.59,2.53,2.53,0,0,1-2.51-2.09l-20.3-120.45a2.28,2.28,0,0,1,.51-2,2.54,2.54,0,0,1,1.89-.94m0-15a17.51,17.51,0,0,0-17.19,20.41L648,778.65a17.47,17.47,0,0,0,17.31,14.59,17.24,17.24,0,0,0,11.07-4L702.11,768l31.37,38a13.29,13.29,0,0,0,18.71,1.78l18.76-15.5a13.29,13.29,0,0,0,1.78-18.71l-31.37-38,29.19-24.12a17.48,17.48,0,0,0-5-29.85L651.06,638.92a17.57,17.57,0,0,0-6.15-1.12Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/button.ac5708c32fe6f7e29c63f643a9142eb2.svg";
export { ForwardRef as ReactComponent };